import React from 'react';
import PropTypes from 'prop-types';
import { UniversalLink } from '@plone/volto/components';

// Cabeçalho de seção dos blocos: selo (eyebrow) e título com a linha cinza e o
// fio amarelo. Desde 22/10/2026 tem um link opcional à direita do título, com
// texto e endereço livres ("Veja todos os comunicados"), e serve também ao
// bloco Cabeçalho de seção. Sem o link, o HTML é o mesmo de antes (selo e h2
// soltos, com as classes do bloco). Com o link, título e link dividem uma
// linha (.ag-secao-cab, em theme/components.css), que passa a levar a linha e
// o fio. O link fica fora do h2: o título continua só o nome da seção para
// quem navega pelos títulos com leitor de tela.
const limpo = (v) => (typeof v === 'string' ? v.trim() : '');

const CabecalhoSecao = ({ prefixo, selo, titulo, linkTexto, linkHref }) => {
  const texto = limpo(linkTexto);
  const href = limpo(linkHref);
  const heading = titulo ? (
    <h2 className={`${prefixo}__heading`}>{titulo}</h2>
  ) : null;
  return (
    <>
      {selo && <span className={`${prefixo}__eyebrow`}>{selo}</span>}
      {heading && texto && href ? (
        <div className={`ag-secao-cab ${prefixo}__cab`}>
          {heading}
          <UniversalLink href={href} className="ag-secao-cab__link">
            {texto}
          </UniversalLink>
        </div>
      ) : (
        heading
      )}
    </>
  );
};

CabecalhoSecao.propTypes = {
  prefixo: PropTypes.string.isRequired,
  selo: PropTypes.string,
  titulo: PropTypes.string,
  linkTexto: PropTypes.string,
  linkHref: PropTypes.string,
};

export default CabecalhoSecao;
